/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s4 from 'react-slidedown/lib/slidedown.css';

// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from './Order.sass';
import { setisNotExpiredLogin } from '../../actions/user';
import { getOrderRequest } from '../../api/order';
import { IsValidResponseStatus } from '../../service/util';
// import { checkIsLogin } from '../../service/userService';
import { getAuth } from '../../service/auth';
import SMSCtrl from '../../ctrl/smsCtrl';
import {
  initOrderDetailInfoAction,
  addUploadedOrderImage,
} from '../../actions/order';

import HKOrder from './hkOrder';
import TWOrder from './twOrder';
import INOrder from './inOrder';
import KROrder from './krOrder';
import SGOrder from './sgOrder';

class Order extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    isValidOrder: PropTypes.bool.isRequired,
    setisNotExpiredLogin: PropTypes.func.isRequired,
    initOrderDetailInfoAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let language = lang;
    if (lang === 'hk') {
      language = `${langType}-${lang}`;
    }
    this.state = {
      isShowOrderDetail: false,
      modelData: require(`../../assets/src/scripts/gogovan/order/${lang}/${language}-modelData.json`),
      modelDataText: require(`../../assets/src/scripts/gogovan/order/${lang}/${language}.json`),
      setting: require(`../../assets/src/${lang}/scripts/components/setting.json`),
      // for init order data
      orderIntiData: require(`../../ctrl/orderInti.json`),
      lang
    };
    this.onClickConfirm = this.onClickConfirm.bind(this);
  }

  componentWillMount() {
    this.props.initOrderDetailInfoAction(
      this.state.orderIntiData.orderDetailInfo[this.state.lang],
    );
  }

  componentDidMount() {
    document.body.style.overflowY = 'scroll';
    this.checkIsLogin();
  }

  componentWillUnmount() {
    // localStorageRemove('addresses');
  }

  onClickConfirm() {
    if (this.props.isValidOrder) {
      this.setState({ isShowOrderDetail: !this.state.isShowOrderDetail });
    }
  }

  checkIsLogin() {
    getOrderRequest(null, this.props.currentLocale)
      .then(result => {
        IsValidResponseStatus(result.status, this.props.setisNotExpiredLogin);
      })
      .catch(() => {
        this.props.setisNotExpiredLogin();
      });
  }

  render() {
    // Process the dataModel first before the template rendering
    return (
      <div>
        {this.state.lang === 'hk' ? (
          <HKOrder
            modelData={this.state.modelData}
            modelDataText={this.state.modelDataText}
            setting={this.state.setting}
            lang={this.state.lang}
            onClickConfirm={this.onClickConfirm}
            isShowOrderDetail={this.state.isShowOrderDetail}
          />
        ) : (
          ''
        )}
        {this.state.lang === 'tw' ? (
          <TWOrder
            modelData={this.state.modelData}
            modelDataText={this.state.modelDataText}
            setting={this.state.setting}
            lang={this.state.lang}
            onClickConfirm={this.onClickConfirm}
            isShowOrderDetail={this.state.isShowOrderDetail}
          />
        ) : (
          ''
        )}
        {this.state.lang === 'in' ? (
          <INOrder
            modelData={this.state.modelData}
            modelDataText={this.state.modelDataText}
            setting={this.state.setting}
            lang={this.state.lang}
            onClickConfirm={this.onClickConfirm}
            isShowOrderDetail={this.state.isShowOrderDetail}
          />
        ) : (
          ''
        )}
        {this.state.lang === 'kr' ? (
          <KROrder
            modelData={this.state.modelData}
            modelDataText={this.state.modelDataText}
            setting={this.state.setting}
            lang={this.state.lang}
            onClickConfirm={this.onClickConfirm}
            isShowOrderDetail={this.state.isShowOrderDetail}
          />
        ) : (
          ''
        )}
        {this.state.lang === 'sg' ? (
          <SGOrder
            modelData={this.state.modelData}
            modelDataText={this.state.modelDataText}
            setting={this.state.setting}
            lang={this.state.lang}
            onClickConfirm={this.onClickConfirm}
            isShowOrderDetail={this.state.isShowOrderDetail}
          />
        ) : (
          ''
        )}
        {/* check whether user login */}
        {getAuth().phone !== null && typeof getAuth().phone !== 'undefined' ? (
          <SMSCtrl />
        ) : (
          ''
        )}
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  isValidOrder: state.order.isValidOrder,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  images: state.order.images,
});
const mapDispatch = {
  setisNotExpiredLogin,
  initOrderDetailInfoAction,
  addUploadedOrderImage,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2, s4)(Order),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order.js